<div class="login-bg" role="img" aria-label="EMSYS CellSPY VLA battery installation"></div>

<main class="login-stage">
  <form class="login-card" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <img class="login-logo" src="assets/images/logo-white.svg" alt="EMSYS" />

    <h1 class="login-title">Welcome back</h1>
    <p class="login-subtitle">Sign in to the EMSYS Sales Portal.</p>

    <div class="login-fields">
      <div class="login-group">
        <label class="login-field">
          <input
            type="email"
            id="email"
            placeholder="Email address"
            aria-label="Email address"
            formControlName="email"
            autocomplete="email"
            autofocus
            />
        </label>
        @if (showError('email', 'required')) {
          <p class="login-error">Email is required.</p>
        } @else if (showError('email', 'email')) {
          <p class="login-error">Enter a valid email address.</p>
        }
      </div>

      <div class="login-group">
        <label class="login-field">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            placeholder="Password"
            aria-label="Password"
            formControlName="password"
            autocomplete="current-password"
            />
          <button
            type="button"
            class="login-eye"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            (click)="showPassword = !showPassword"
            >
            @if (!showPassword) {
              <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
                <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            } @else {
              <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            }
          </button>
        </label>
        @if (showError('password', 'required')) {
          <p class="login-error">Password is required.</p>
        }
      </div>
    </div>

    @if (errorMessage) {
      <p class="login-error login-auth-error" role="alert">{{ errorMessage }}</p>
    }

    <button type="submit" class="login-submit" [disabled]="loading$ | async">
      Sign in
      @if (loading$ | async) {
        <span class="login-spinner" aria-hidden="true"></span>
      } @else {
        <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 12h15" />
          <path d="M13 6l6 6-6 6" />
        </svg>
      }
    </button>

    <a class="login-forgot" routerLink="/reset-password">Forgot password?</a>
  </form>
</main>
